import { render } from "./HorseChart.vue?vue&type=template&id=f332b512&scoped=true"
import script from "./HorseChart.vue?vue&type=script&lang=js"
export * from "./HorseChart.vue?vue&type=script&lang=js"

import "./HorseChart.vue?vue&type=style&index=0&id=f332b512&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f332b512"]])

export default __exports__